module.exports = __webpack_public_path__ + "img/default1.4585e5d0.png";